import React from "react";
import { UserCog, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Red sticky banner shown at the top of the regular /app layout when an admin
 * is impersonating another user. Reads the saved admin session from
 * `localStorage["impersonation_return"]` and, on click of "Torna all'admin",
 * restores it and navigates to /app/admin.
 */
export default function ImpersonationBanner() {
  const navigate = useNavigate();
  let saved = null;
  try {
    const raw = localStorage.getItem("impersonation_return");
    saved = raw ? JSON.parse(raw) : null;
  } catch {
    saved = null;
  }
  if (!saved) return null;

  const impersonated = (() => {
    try {
      return JSON.parse(localStorage.getItem("auth_user") || "{}");
    } catch {
      return {};
    }
  })();

  const returnToAdmin = () => {
    try {
      localStorage.setItem("auth_token", saved.token);
      localStorage.setItem("auth_user", JSON.stringify(saved.user));
      localStorage.removeItem("impersonation_return");
    } catch {
      // ignore
    }
    // Full reload so AuthContext + FicStatusContext re-init cleanly
    window.location.href = "/app/admin";
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="w-full bg-gradient-to-r from-red-600 to-red-500 text-white sticky top-0 z-50 shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <UserCog className="w-4 h-4 shrink-0" />
          <span className="font-semibold truncate">
            Stai impersonando
            <span className="ml-1.5 font-mono bg-white/15 rounded px-1.5 py-0.5 text-xs">
              {impersonated?.email || "?"}
            </span>
          </span>
          <span className="hidden md:inline text-white/70 text-xs">
            · vedi la piattaforma dai suoi occhi. Nessuna azione è nascosta.
          </span>
        </div>
        <button
          onClick={returnToAdmin}
          data-testid="impersonation-return-btn"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-white text-red-700 font-bold text-xs hover:bg-red-50 shadow-sm shrink-0"
        >
          <ArrowLeft className="w-3 h-3" /> Torna all&apos;admin
        </button>
      </div>
    </div>
  );
}

/** Helper: is an impersonation session currently active? */
export function isImpersonating() {
  try {
    return !!localStorage.getItem("impersonation_return");
  } catch {
    return false;
  }
}
